import Vue from 'vue';
import { makeDateStringFromKotlin } from 'union_kotlin';

Vue.filter('ordinalNumberWithWord', (index) => {
  if (index === undefined) return '';
  if (index === 0) return 'Prvý';
  if (index === 1) return 'Druhý';
  if (index === 2) return 'Tretí';
  if (index === 3) return 'Štvrtý';
  if (index === 4) return 'Piaty';
  if (index === 5) return 'Šiesty';
  if (index === 6) return 'Siedmy';
  if (index === 7) return 'Ôsmy';
  return 'Deviaty';
});

Vue.filter('priceFormat', (number, addSpaces = false) => {
  if (!number || typeof number !== 'number') return '0,00€';

  if (!addSpaces) return `${number.toFixed(2)} €`.replace('.', ',');

  const parts = number.toString().split('.');
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  return `${parts.join(',')} €`;
});

Vue.filter('kotlinDate', (date) => {
  if (!date) return '';
  let { day, month } = date;
  month = date.month;
  month = month < 10 ? `0${month}` : month;
  day = day < 10 ? `0${day}` : day;
  return `${day}.${month}.${date.year}`;
});

Vue.filter('dateTimestampToSVK', (date) => {
  if (!date) return '';
  let month = date.getMonth() + 1;
  month = month < 10 ? `0${month}` : month;
  let day = date.getDate();
  day = day < 10 ? `0${day}` : day;
  return `${day}.${month}.${date.getFullYear()}`;
});

Vue.filter('makeAddress', (address) => `${address?.street} ${address?.streetNumber}, ${address.zip} ${address.city}`);

Vue.filter('makeLongDate', (kotlinDate, wordCase) => {
  if (!kotlinDate) return '';
  return makeDateStringFromKotlin(kotlinDate, true, wordCase);
});

Vue.filter('capitalize', (str) => {
  if (typeof str !== 'string' && str.length === 0) return '';
  const [firstLetter, ...restLetters] = str.split('');
  return `${firstLetter.toUpperCase()}${restLetters.join('')}`;
});

Vue.filter('fileSizeFormat', (bytes) => {
  if (typeof bytes !== 'number') return '0 Kb';

  if (Math.abs(bytes) < 1024) return `${bytes} B`;

  const units = ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  let unitIndex = -1;

  do {
    bytes /= 1024;
    unitIndex += 1;
  } while (Math.round(Math.abs(bytes) * 10) / 10 >= 1024 && unitIndex < units.length - 1);

  return `${bytes.toFixed(2)} ${units[unitIndex]}`;
});
